import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';
import './Contact.css';

const WhatsappFloat = () => (
  <motion.a
    href="https://wa.me/5531995170464?text=Olá! Gostaria de saber mais sobre os serviços da MicroCodie."
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-float"
    aria-label="Abrir conversa no WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1, duration: 0.5 }}
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.9 }}
  >
    <FaWhatsapp />
    <span className="whatsapp-tooltip">Fale conosco no WhatsApp</span>
  </motion.a>
);

export default WhatsappFloat; 